export default {
  hasConsent: state => state.consentStatus !== null,
  hasAcceptedAll: state => state.consentStatus === 'accepted',
  hasRejectedAll: state => state.consentStatus === 'rejected',
  hasCustomSettings: state => state.consentStatus === 'custom',
  acceptedCookies: state => {
    if (state.consentStatus === 'accepted') {
      return Object.keys(state.preferences)
    }
    if (state.consentStatus === 'custom') {
      return Object.keys(state.preferences).filter(
        key => state.preferences[key]
      )
    }
    return ['necessary']
  },
  showBanner: state => state.bannerVisible && state.consentStatus === null,
  getPreferences: state => state.preferences
}
